import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdDialog } from '@angular/material';
import { TransactionRule } from 'app/entities/transaction-profile/right.model';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { ReviewStatus } from 'app/entities/transaction-profile/right.model';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { formatDisplayDate } from 'app/shared/utils/date-format.util';

@Component({
  selector: 'rule-history-dialog',
  templateUrl: './rule-history-dialog.component.html',
  styleUrls: ['./rule-history-dialog.component.css']
})
export class RuleHistoryDialogComponent implements OnInit {
  rule: TransactionRule;
  clientId: number;
  history: TransactionRule[] = [];
  isLoading = false;
  isRestoring = false;
  ReviewStatus = ReviewStatus;

  constructor(
    public dialogRef: MdDialogRef<RuleHistoryDialogComponent>,
    @Optional() @Inject(MD_DIALOG_DATA) public data: { rule: TransactionRule; clientId?: number },
    private transactionProfileService: EntityTransactionProfileService
  ) {
    if (data && data.rule) {
      this.rule = data.rule;
      this.clientId = data.clientId;
    }
  }

  ngOnInit() {
    if (this.rule && this.rule.id) {
      this.loadHistory();
    }
  }

  loadHistory() {
    this.isLoading = true;
    this.transactionProfileService.getTransactionRuleHistory(this.rule.id)
      .subscribe(
        history => {
          const historyArray = history || [];
          // Sort by date (most recent first): use lastModifiedOn if available, otherwise createdOn
          this.history = historyArray.sort((a, b) => {
            const dateA = a.lastModifiedOn || a.createdOn;
            const dateB = b.lastModifiedOn || b.createdOn;
            
            if (!dateA && !dateB) return 0;
            if (!dateA) return 1; // Put items without date at the end
            if (!dateB) return -1; // Put items without date at the end
            
            // Compare dates: most recent first (descending order)
            return new Date(dateB).getTime() - new Date(dateA).getTime();
          });
          this.isLoading = false;
        },
        error => {
          console.error('Error loading rule history:', error);
          this.history = [];
          this.isLoading = false;
        }
      );
  }

  getStatusClass(status: any): string {
    if (status === ReviewStatus.FINAL || status === 'FINAL') {
      return 'status-final';
    } else if (status === ReviewStatus.DRAFT || status === 'DRAFT') {
      return 'status-draft';
    }
    return '';
  }

  getStatusText(status: any): string {
    if (status === ReviewStatus.FINAL || status === 'FINAL') {
      return 'FINAL';
    } else if (status === ReviewStatus.DRAFT || status === 'DRAFT') {
      return 'DRAFT';
    }
    return status || 'N/A';
  }

  formatDate(date: Date): string {
    if (!date) return 'N/A';
    return formatDisplayDate(date) || 'N/A';
  }

  getDisplayDate(version: TransactionRule): Date {
    return version.lastModifiedOn || version.createdOn;
  }

  getDisplayDateLabel(version: TransactionRule): string {
    if (version.lastModifiedOn) {
      return 'Last updated';
    } else if (version.createdOn) {
      return 'Created';
    }
    return '';
  }

  isCurrentVersion(version: TransactionRule): boolean {
    return version.id === this.rule.id;
  }

  canRestore(version: TransactionRule): boolean {
    // Can restore if it's not the current version
    return !this.isCurrentVersion(version);
  }

  restoreVersion(version: TransactionRule, event: Event) {
    event.stopPropagation();
    
    if (!this.clientId) {
      alert('Client ID is required to restore a version.');
      return;
    }

    if (!confirm(`Are you sure you want to restore version ${version.id}? This will create or update a DRAFT version with the values from this historical version.`)) {
      return;
    }

    this.isRestoring = true;
    this.transactionProfileService.restoreTransactionRuleVersion(this.clientId, version.id)
      .subscribe(
        restoredRuleId => {
          this.isRestoring = false;
          alert(`Version restored successfully. Rule ID: ${restoredRuleId}`);
          // Reload history to show the new/updated version
          this.loadHistory();
          // Close dialog and return the restored rule ID
          this.dialogRef.close({ restored: true, ruleId: restoredRuleId });
        },
        error => {
          this.isRestoring = false;
          console.error('Error restoring version:', error);
          alert('Error restoring version: ' + (error.message || 'Unknown error'));
        }
      );
  }

  close() {
    this.dialogRef.close();
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/transaction-monitoring/rule-history-dialog/rule-history-dialog.component.ts